import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import {
  EmailFieldComponent,
  PhoneFieldComponent,
  NameField,
  RequestorCapacitySelectComponent,
  SurnameField,
  OneColumn,
  MenuItemsForDropDown,
  PRNumberField,
  TitleSelectComponent,
  PassportComponent,
  TaxNumberComponent,
  TaxTypeSelectComponent,
  IDTypeSelectComponent,
  IDNumberComponent,
} from "@soqs/common";
import HalfColumn from "./userhelpers/halfcolumn";

import React from "react";
import { useFormState } from "react-final-form";
import { dropdownopts, dropdownsloading } from "../../features/AppSlice";
import { useSelector } from "react-redux";

const RequestorDetails = () => {
  const dropdownloading = useSelector(dropdownsloading);
  const dropdownoptions = useSelector(dropdownopts);
  const formstate = useFormState();

  return (
    <>
      <Grid size={{ xs: 12 }} >
        <Card>
          <CardHeader title="Requestor Details" />
          <CardContent>
            <Grid container columnSpacing={1.5} rowSpacing={0.5}>
              <HalfColumn>
                <TitleSelectComponent
                  // do not parse as title is string value
                  titleOptions={MenuItemsForDropDown("title", dropdownoptions)}
                  optionsloading={dropdownloading}
                />
              </HalfColumn>
              <HalfColumn>
                <NameField />
              </HalfColumn>
              {/*             <OneColumn>
              <InitialsField />
            </OneColumn> */}
              <OneColumn>
                <SurnameField />
              </OneColumn>
              {formstate.values?.requestorCapacity === "9" ? (
                /* Only if requestor is a TaxPractitioner (9) */
                <>
                  <HalfColumn>
                    <RequestorCapacitySelectComponent
                      //do not parseInt the value, it will be a string due to frontend cosmetic splits
                      requestorCapacities={MenuItemsForDropDown(
                        "capacity",
                        dropdownoptions
                      )}
                      optionsloading={dropdownloading}
                    />
                  </HalfColumn>
                  <HalfColumn>
                    <PRNumberField />
                  </HalfColumn>
                  <OneColumn>
                    <EmailFieldComponent />
                  </OneColumn>
                </>
              ) : (
                <>
                  <OneColumn>
                    <RequestorCapacitySelectComponent
                      //do not parseInt the value, it will be a string due to frontend cosmetic splits
                      requestorCapacities={MenuItemsForDropDown(
                        "capacity",
                        dropdownoptions
                      )}
                      optionsloading={dropdownloading}
                    />
                  </OneColumn>
                  <OneColumn>
                    <EmailFieldComponent />
                  </OneColumn>
                </>
              )}
              <OneColumn>
                <PhoneFieldComponent />
              </OneColumn>
              <OneColumn>
                <PhoneFieldComponent variant="telephone" required={false} />
              </OneColumn>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{ xs: 12 }} >
        <Card>
          <CardHeader title="Requestor Additional Details" />
          <CardContent>
            <Grid container columnSpacing={1.5} rowSpacing={0.5}>
              <OneColumn>
                <TaxTypeSelectComponent
                  taxoptions={MenuItemsForDropDown(
                    "taxtype_requestor_individual",
                    dropdownoptions,
                    true
                  )}
                  optionsloading={dropdownloading}
                />
              </OneColumn>
              <OneColumn>
                <TaxNumberComponent
                  required={
                    !(
                      formstate.values?.requestorCapacity === "13" ||
                      formstate.values?.idtype === 2 ||
                      formstate.values?.trustType === 3
                    )
                  }
                />
              </OneColumn>
              <OneColumn>
                <IDTypeSelectComponent
                  idoptions={MenuItemsForDropDown(
                    "idtype",
                    dropdownoptions,
                    true
                  )}
                  optionsloading={dropdownloading}
                />
              </OneColumn>
              <OneColumn>
                {formstate.values?.idtype === 1 ? (
                  <IDNumberComponent />
                ) : (
                  <PassportComponent />
                )}
              </OneColumn>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

export default RequestorDetails;
